import {obtenerSolicitudTipoId, SolicitudTiposEnum} from './afiliaciones/solicitud-tipos.enum';
import {EstadosCivil} from './estados-civil';

export class Solicitud {
  private static PORTAL_EMPRESAS_ID = 2;

  constructor(
    public fechaAfiliacion: string,
    public af: number,
    public cm: number,
    public portal: number,
    public tipo: number
  ){ }


  static mapearDesdeFormularioAFT(solicitudTipo: SolicitudTiposEnum, obj: any, cantidadCm?: any) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];

    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    return new Solicitud(
      fechaConHoraActual,
      obj['beneficiariosAFI'],
      obj['beneficiariosACM'] ?? cantidadCm,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo)
    );
  }

  static mapearDesdeFormularioNCM(solicitudTipo: SolicitudTiposEnum, obj: any, cantidadCm?: any) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];

    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    return new Solicitud(
      fechaConHoraActual,
      obj['beneficiariosAFI'],
      obj['beneficiariosACM'] ?? cantidadCm,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo)
    );
  }

  static mapearDesdeFormularioRIT(solicitudTipo: SolicitudTiposEnum, fechaRetiro: any) {
    const horaActual = new Date().toLocaleTimeString('it-IT');
    const fechaRetiroConHoraActual = `${fechaRetiro}T${horaActual}`;
    return new Solicitud(
      fechaRetiroConHoraActual,
      0,
      0,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo),
    );
  }

  static mapearDesdeFormularioRIB(solicitudTipo: SolicitudTiposEnum, fechaRetiro: any) {
    const horaActual = new Date().toLocaleTimeString('it-IT');
    const fechaRetiroConHoraActual = `${fechaRetiro}T${horaActual}`;
    return new Solicitud(
      fechaRetiroConHoraActual,
      0,
      0,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo),
    );
  }

  static mapearDesdeFormularioCEC(solicitudTipo: SolicitudTiposEnum, obj: any) {
    const fechaActual = new Date().toISOString().split('T')[0];
    const horaActual = new Date().toISOString().split('T')[1];

    const fechaConHoraActual = `${fechaActual}T${horaActual}`;
    const estado = obj?.estadoCivil;

    const estadoCivil = (
      estado === EstadosCivil.SOLTERO ||
      estado === EstadosCivil.SEPARADO ||
      estado === EstadosCivil.VIUDO
    ) ? 1 : 0;
    return new Solicitud(
      fechaConHoraActual,
      estadoCivil || 0,
      0,
      this.PORTAL_EMPRESAS_ID,
      obtenerSolicitudTipoId(solicitudTipo)
    );
  }
}
